import { render, staticRenderFns } from "./Behaviour.vue?vue&type=template&id=e1d90be6&"
import script from "./Behaviour.vue?vue&type=script&lang=js&"
export * from "./Behaviour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports